import axios from "axios";
import {authHeader} from "./authHeader";

const API_URL = process.env.REACT_APP_API_URL;
  
const getRoles = (params) => {
  return axios.get(API_URL + '/api/roles', { 
    params: params,
    headers: authHeader() });
};

const addRole = async (formData) => {
  const response = await axios.post(API_URL + "/api/roles", formData, {  
    headers: authHeader()
  });
  return response.data;
};

const updateRole = async (r_id,  formData ) => {
  const response = await axios.put(API_URL + `/api/roles/update/${r_id}`, formData, {
    headers: authHeader()
  });
  return response.data; 
};

const deleteRole = async (r_id) => {
  const response = await axios.delete(API_URL +`/api/roles/delete/${r_id}`,{ headers:authHeader()});
  return response;
};

const ROLEAPI={
  getRoles,
  addRole,
  updateRole,
  deleteRole
}

export default ROLEAPI;